import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://jxlgaeaejoufmhschikh.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp4bGdhZWFlam91Zm1oc2NoaWtoIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTYxOTE1ODEsImV4cCI6MjAxMTc2NzU4MX0.ZWCI-9jKvDcmTvbz-E-loRYVxQRvC2iBMVsrJzwizz4';

export const SUPABASE_CLIENT = createClient(supabaseUrl, supabaseKey);